import React from 'react'

import Input from '../../atoms/Input/Input'
import Text from '../../atoms/Text/Text'

interface RadioButtonGroupProps {
  options: string[]
  value: string
  onChange: (value: string) => void
  name: string
  className?: string
  radioDivClass?: string
  radioSize?: 'small' | 'medium' | 'large'
  disabled?: boolean
}

const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
  options,
  value,
  onChange,
  name,
  className,
  radioDivClass = '',
  radioSize = 'small',
  disabled = false
}) => {
  const getInnerDotClasses = (option: string) => {
    const isSelected = value === option
    const baseSize = radioSize === 'small' ? 'w-1.5 h-1.5' : radioSize === 'large' ? 'w-2.5 h-2.5' : 'w-2 h-2'

    if (!isSelected) {
      return 'hidden'
    }

    return `${baseSize} bg-white rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2`
  }

  return (
    <div className={className}>
      {options.map((option, idx) => (
        <label
          key={idx}
          className={`flex items-center radio__text--${radioSize} ${radioDivClass} ${
            disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
          } group`}
        >
          <div className="relative">
            <Input
              id={`${name}-${option}-${idx}`}
              type="radio"
              name={name}
              value={option}
              checked={value === option}
              onChange={() => !disabled && onChange(option)}
              disabled={disabled}
              className={`radio radio--${radioSize} appearance-none rounded-full border-2 relative cursor-pointer`}
            />
            <div className={getInnerDotClasses(option)} />
          </div>
          <Text
            id={`${name}-${option}-label`}
            className={`text-inherit ${disabled ? 'text-background-primary-disabled' : 'text-black'} select-none`}
            as="div"
          >
            {option}
          </Text>
        </label>
      ))}
    </div>
  )
}

export default RadioButtonGroup
